import API from "utils/API";
import authHeader from "utils/auth-header";
import { getQeuryParams } from "utils/queryParamsUtil";
import { ICarnetsMealsStatisticsResponse } from "../domain/ICarnetsMealsStatisticsResponse";
import { IConstructionStatistics } from "../domain/IConstructionStatistics";
import { IConstructionStatisticsRequestParams } from "../domain/IConstructionStatisticsRequestParams";
import { ICreditsStatistics } from "../domain/ICreditsStatistics";
import { IFinancialStatistics } from "../domain/IFinancialStatistics";
import { IResourceCostsStatistics } from "../domain/IResourceCostsStatistics";
import { ISalariesStatisticsResponse } from "../domain/ISalariesStatisticsResponse";
import { ISummaryStatistics } from "../domain/ISummaryStatistics";
import { IValuationsInvestmentsStatistics } from "../domain/IValuationsInvestmentsStatistics";
import { IYearRequestParams } from "../domain/IYearRequestParams";
import { ITotalFinancials } from "../domain/ITotalFinancials";

const getConstructionStatistics = async (
  data?: IConstructionStatisticsRequestParams
): Promise<IConstructionStatistics> => {
  var headers = authHeader();
  try {
    const response = await API.get<IConstructionStatistics>(
      `/statistics/protected/construction-projects${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getOtherProjectsStatistics = async (
  data?: IConstructionStatisticsRequestParams
): Promise<IConstructionStatistics> => {
  var headers = authHeader();
  try {
    const response = await API.get<IConstructionStatistics>(
      `/statistics/protected/other-projects${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getFinancialStatistics = async (
  data?: IConstructionStatisticsRequestParams
): Promise<IFinancialStatistics> => {
  var headers = authHeader();
  try {
    const response = await API.get<IFinancialStatistics>(
      `/statistics/protected/fixed-costs${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getCarnetsMealsStatistics = async (
  data?: IYearRequestParams
): Promise<ICarnetsMealsStatisticsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<ICarnetsMealsStatisticsResponse>(
      `/statistics/protected/carnet-meal-costs${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getSalariesStatistics = async (
  data?: IYearRequestParams
): Promise<ISalariesStatisticsResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<ISalariesStatisticsResponse>(
      `/statistics/protected/salary-costs${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getResourceCostsStatistics = async (
  data?: IYearRequestParams
): Promise<IResourceCostsStatistics> => {
  var headers = authHeader();
  try {
    const response = await API.get<IResourceCostsStatistics>(
      `/statistics/protected/resource-costs${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getValuationsStatistics = async (
  data?: IConstructionStatisticsRequestParams
): Promise<IValuationsInvestmentsStatistics> => {
  var headers = authHeader();
  try {
    const response = await API.get<IValuationsInvestmentsStatistics>(
      `/statistics/protected/valuation-investments-borrowings${getQeuryParams(
        data
      )}`,
      { headers }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};

const getCreditsStatistics = async (
  data?: IConstructionStatisticsRequestParams
): Promise<ICreditsStatistics> => {
  var headers = authHeader();
  try {
    const response = await API.get<ICreditsStatistics>(
      `/statistics/protected/loans${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getSummaryStatistics = async (
  data?: IYearRequestParams
): Promise<ISummaryStatistics> => {
  var headers = authHeader();
  try {
    const response = await API.get<ISummaryStatistics>(
      `/statistics/protected/summary${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getTotalFinancials = async (
  data?: IYearRequestParams
): Promise<ITotalFinancials> => {
  var headers = authHeader();
  try {
    const response = await API.get<ITotalFinancials>(
      `/statistics/protected/financials${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export function FormatNumber(number: number | undefined): string {
  if (number) {
    return new Intl.NumberFormat("sr-SR").format(number);
  } else {
    return '0';
  }
}

export const mapProjectCategories = (category: string) => {
  switch (category.toLowerCase()) {
    case "construction":
      return "Gradjevina";
    case "concrete_base":
      return "Betonska baza";
    case "asphalt_base":
      return "Asvaltna baza";
    case "warehouse":
      return "Magacin";
    case "stone_pit":
      return "Kamenolom";
    case "production":
      return "Proizvodnja bg";
    case "loan":
      return "Krediti";
    case "insurance":
      return "Osiguranje";
    case "vat":
      return "PDV";
    case "contribution":
      return "Doprinosi";
    case "tax":
      return "Porez";
    case "investment":
      return "Investicije";
    case "donation":
      return "Donacije";
    case "sponsorship":
      return "Sponzorstva";
    case "borrowing":
      return "Pozajmice";
    case "other":
      return "Ostalo";
    case "checkmark":
      return "Kvačkica";
  }
};
export const StatisticsService = {
  getConstructionStatistics,
  getOtherProjectsStatistics,
  getFinancialStatistics,
  getCarnetsMealsStatistics,
  getSalariesStatistics,
  getResourceCostsStatistics,
  getValuationsStatistics,
  getCreditsStatistics,
  getSummaryStatistics,
  getTotalFinancials
};
